module.exports = __webpack_public_path__ + "img/iphone6_splash.cc66b573.png";